import InnoSearchMessage from '@/components/ChatSection/componnents/InnoSearchMessage/InnoSearchMessage'
import UserMessage from '@/components/ChatSection/componnents/UserMessage/UserMessage'
import type {UseMessagesReturn} from '@/components/ChatSection/hooks/useMessages'
import useChatMessages, {getMessagesQueryKey} from '@/lib/chat/hooks/useChatMessages'
import type {Thread} from '@/models/threadModel'

interface Props {
  activeThreadId: Thread['id'] | undefined
  isGenerating: boolean
  submitMessage: UseMessagesReturn['submitMessage']
  setQ: Dispatch<SetStateAction<string>>
  setSendMessagePlaceholder: Dispatch<SetStateAction<string>>
}

const Messages = deepMemo<PropsWithChildren<Props>>(function Messages({
  activeThreadId,
  isGenerating,
  submitMessage,
  setQ,
  setSendMessagePlaceholder,
  children,
}) {
  const queryClient = useQueryClient()
  // Note: we are not consider moving the query to Chat component because that will suspend the whole Chat component
  // TODO: convert to useSuspenseQuery
  const {data: messages, isFetching: isLoadingMessages} = useChatMessages(
    {threadId: activeThreadId},
    {
      select: result => {
        const currentData = queryClient.getQueryData<typeof result>(
          getMessagesQueryKey({threadId: activeThreadId}),
        )
        if (!currentData || result.length >= currentData.length) {
          return result
        }
        return currentData
      },
      // TODO: fix case when the first message is error (and don't come with a threadId) -> queryFn will be called again will null queryKey[1] and result in empty messages (the failed message getting clear)
      placeholderData: (prevData, prevQuery) => {
        // if activeThreadId change from undefined to a valid id, this is change metadata when open a new thread => preserve the old message
        if (prevQuery && prevQuery.queryKey[1] === undefined) {
          return prevData
        }
        return []
      },
      enabled: !isGenerating,
    },
  )

  return (
    <>
      {!isLoadingMessages && messages?.length === 0 && children}
      {/* TODO: virtualize messsages */}
      {messages?.map((message, i) => {
        if (message.author === 'user') {
          return <UserMessage key={i} message={message.content} />
        }
        return (
          <InnoSearchMessage
            key={i}
            message={message}
            submitMessage={submitMessage}
            isLoading={i === messages.length - 1 ? isGenerating : false}
            isLatest={i === messages.length - 1}
            setQ={setQ}
            setSendMessagePlaceholder={setSendMessagePlaceholder}
          />
        )
      })}
      {/* Use this to test the content */}
      {/* <InnoSearchMessage
        message={{
          author: 'assistant',
          content: TEST_MESSAGE,
        }}
        submitMessage={submitMessage}
        isLoading={false}
        isLatest={true}
        setQ={setQ}
        setSendMessagePlaceholder={setSendMessagePlaceholder}
      /> */}
    </>
  )
})()

export default Messages
